import '../sass/project.scss';

import mediumZoom from 'medium-zoom'

window.mediumZoom = mediumZoom;
